import ngAnimate from 'angular-animate';
import ngTouch from 'angular-touch';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup';
import './angular-locale_es-es.js';
import inputDatepickerComponent from './inputDatepicker.component';

let inputDatepickerModule = angular.module('components.inputDatepicker', [
  ngAnimate,
  ngTouch,
  datepickerPopup
])

.component('inputDatepicker', inputDatepickerComponent)

.name;

export default inputDatepickerModule;



// WEBPACK FOOTER //
// ./client/app/components/inputDatepicker/inputDatepicker.js